import { render, staticRenderFns } from "./RepairStatus.vue?vue&type=template&id=0a2bdfc6&"
import script from "./RepairStatus.vue?vue&type=script&lang=js&"
export * from "./RepairStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports